import { MultilingualKeyDto } from '@pharmac-extranet/management-api'
import { UseTranslationOptions, useTranslation } from 'react-i18next'
import { getMultilingualKey } from '../utils/getMultilingualKey'

export const useLanguage = (
  ns?: undefined | ('extranet' | 'common')[],
  options?: UseTranslationOptions<undefined> | undefined
) => {
  const useTranslationHook = useTranslation(ns, options)

  return {
    ...useTranslationHook,
    key: (key: MultilingualKeyDto) => getMultilingualKey(key, useTranslationHook.i18n.language),
  }
}
